import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const heroSlides = [
    {
      title: "Soluciones Electrónicas Automotrices",
      subtitle: "Diagnóstico inteligente y reparación especializada",
      description: "Expertos en programación de módulos, llaves inteligentes y sistemas electrónicos vehiculares con tecnología de vanguardia. Análisis con scanner de inteligencia artificial para resultados precisos y diagnósticos avanzados.",
      cta: "Conocer Servicios",
      ctaLink: "/servicios",
      image: "https://public.readdy.ai/ai/img_res/00da2d5e3e4758f7d10c61232f375598.jpg"
    },
    {
      title: "Programación de Módulos y Llaves",
      subtitle: "Tecnología avanzada para tu vehículo",
      description: "Servicios especializados en programación de ECU, BCM, llaves inteligentes y sistemas de seguridad vehicular. Scanner con inteligencia artificial para análisis completo y diagnóstico de precisión.",
      cta: "Ver Productos",
      ctaLink: "/productos",
      image: "https://readdy.ai/api/search-image?query=Automotive%20key%20programming%20and%20ECU%20module%20programming%20equipment%2C%20electronic%20car%20keys%2C%20diagnostic%20computers%2C%20professional%20automotive%20locksmith%20tools%2C%20modern%20workshop%20with%20red%20and%20black%20color%20scheme&width=1200&height=600&seq=hero2&orientation=landscape"
    },
    {
      title: "Baterías Bosch Certificadas",
      subtitle: "Calidad alemana y máxima durabilidad",
      description: "Venta e instalación de baterías Bosch originales y certificadas. Tecnología alemana de vanguardia con garantía extendida. Instalación profesional incluida y asesoría especializada para tu vehículo.",
      cta: "Ver Baterías",
      ctaLink: "/productos?category=Baterías",
      image: "https://readdy.ai/api/search-image?query=Bosch%20automotive%20batteries%20display%20in%20professional%20auto%20parts%20store%2C%20original%20certified%20Bosch%20car%20batteries%2C%20German%20automotive%20battery%20technology%2C%20clean%20modern%20automotive%20service%20center&width=1200&height=600&seq=hero3&orientation=landscape"
    }
  ];

  const services = [
    {
      icon: "ri-cpu-line",
      title: "Programación de Módulos",
      description: "ECU, BCM, ABS y todos los módulos electrónicos de tu vehículo",
      features: ["Diagnóstico avanzado", "Programación ECU", "Reparación BCM"]
    },
    {
      icon: "ri-key-2-line",
      title: "Llaves Inteligentes",
      description: "Programación y reparación de llaves con chip y sistemas keyless",
      features: ["Llaves con chip", "Sistemas keyless", "Controles remotos"]
    },
    {
      icon: "ri-tools-line",
      title: "Diagnóstico Automotriz",
      description: "Diagnóstico completo con equipos de última generación",
      features: ["Scanner profesional", "Análisis de fallas", "Mantenimiento predictivo"]
    },
    {
      icon: "ri-battery-line",
      title: "Baterías Bosch",
      description: "Venta e instalación de baterías Bosch de alta calidad y durabilidad",
      features: ["Calidad Bosch", "Instalación incluida", "Garantía extendida"]
    }
  ];

  // Productos destacados - Por marcas de vehículos
  const products = [
    {
      id: 1,
      name: "Toyota Corolla",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Toyota%20Corolla%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=toyota-corolla&orientation=squarish",
      category: "Toyota",
      description: "Bobina de encendido original para Toyota Corolla, garantiza un encendido perfecto",
      features: ["Calidad original", "Fácil instalación", "Garantía incluida"],
      inStock: true,
      rating: 4.8,
      reviews: 24
    },
    {
      id: 2,
      name: "Chevrolet Spark",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Chevrolet%20Spark%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=chevrolet-spark&orientation=squarish",
      category: "Chevrolet",
      description: "Bobina de encendido específica para Chevrolet Spark, máximo rendimiento",
      features: ["Alta durabilidad", "Rendimiento óptimo", "Instalación rápida"],
      inStock: true,
      rating: 4.9,
      reviews: 18
    },
    {
      id: 3,
      name: "Nissan Sentra",
      image: "https://readdy.ai/api/search-image?query=Professional%20automotive%20ignition%20coil%20for%20Nissan%20Sentra%2C%20high-quality%20car%20ignition%20coil%20component%2C%20automotive%20electrical%20part%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=nissan-sentra&orientation=squarish",
      category: "Nissan",
      description: "Bobina de encendido para Nissan Sentra, tecnología avanzada y confiabilidad",
      features: ["Tecnología avanzada", "Larga duración", "Fácil mantenimiento"],
      inStock: true,
      rating: 4.7,
      reviews: 32
    },
    {
      id: 4,
      name: "Batería Bosch S4",
      image: "https://readdy.ai/api/search-image?query=Bosch%20S4%20automotive%20battery%2C%20high-quality%20car%20battery%2C%20professional%20automotive%20battery%20with%20Bosch%20branding%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=bosch-battery&orientation=squarish",
      category: "Baterías",
      description: "Batería Bosch S4 de alta calidad, tecnología alemana y máxima durabilidad",
      features: ["Tecnología alemana", "Larga duración", "Instalación incluida"],
      inStock: true,
      rating: 4.9,
      reviews: 45
    }
  ];

  const whyChooseUs = [
    {
      icon: "ri-award-line",
      title: "Experiencia Comprobada",
      description: "Más de 10 años especializados en electrónica automotriz"
    },
    {
      icon: "ri-tools-fill",
      title: "Tecnología Avanzada",
      description: "Equipos de última generación para diagnóstico y programación"
    },
    {
      icon: "ri-team-line",
      title: "Personal Certificado",
      description: "Técnicos especializados con certificaciones internacionales"
    },
    {
      icon: "ri-time-line",
      title: "Servicio Rápido",
      description: "Diagnóstico en el mismo día y reparaciones eficientes"
    },
    {
      icon: "ri-shield-check-line",
      title: "Garantía Total",
      description: "Garantía en todos nuestros servicios y productos"
    },
    {
      icon: "ri-robot-line",
      title: "Análisis de IA",
      description: "Diagnóstico inteligente con tecnología de inteligencia artificial"
    }
  ];

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);

    // Add structured data for homepage
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Mechatronicx SAS - Inicio",
      "description": "Soluciones electrónicas automotrices especializadas en Bogotá",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
      "mainEntity": {
        "@type": "Organization",
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}#organization`,
        "name": "Mechatronicx SAS",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`,
        "logo": "https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+573202047129",
          "contactType": "customer service"
        }
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      clearInterval(interval);
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const handleWhatsAppContact = () => {
    window.open('https://wa.me/573202047129', '_blank');
  };

  const handlePhoneCall = () => {
    window.open('tel:+573202047129', '_self');
  };

  const handleQuoteRequest = () => {
    window.open('https://wa.me/573202047129?text=Hola, me gustaría solicitar una cotización para mis servicios automotrices', '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-lg fixed w-full top-0 z-50">
        <div className="container mx-auto px-4 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-2 md:space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                alt="Mechatronicx Logo" 
                className="h-8 md:h-12 w-auto"
              />
              <div>
                <h1 className="text-sm md:text-xl font-bold text-gray-900">MECHATRONICX</h1>
                <p className="text-xs text-gray-600 hidden md:block">Soluciones Electrónicas Automotrices</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              <Link to="/" className="text-red-600 font-semibold cursor-pointer">Inicio</Link>
              <Link to="/servicios" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Servicios</Link>
              <Link to="/productos" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Productos</Link>
              <Link to="/empresas" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Empresas</Link>
              <Link to="/blog" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Blog</Link>
              <button 
                onClick={handleQuoteRequest}
                className="bg-red-600 text-white px-4 xl:px-6 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base"
              >
                Cotizar Ahora
              </button>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden text-gray-700 cursor-pointer p-2"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-3 pt-4">
                <Link 
                  to="/" 
                  className="text-red-600 font-semibold cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Inicio
                </Link>
                <Link 
                  to="/servicios" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Servicios
                </Link>
                <Link 
                  to="/productos" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Productos
                </Link>
                <Link 
                  to="/empresas" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Empresas
                </Link>
                <Link 
                  to="/blog" 
                  className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer py-2 px-4 rounded-lg"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Blog
                </Link>
                <button 
                  onClick={() => {
                    handleQuoteRequest();
                    setIsMobileMenuOpen(false);
                  }}
                  className="bg-red-600 text-white px-6 py-3 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer mx-4 text-center"
                >
                  Cotizar Ahora
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative h-screen overflow-hidden mt-16 md:mt-20">
        <div className="absolute inset-0">
          <img 
            src={heroSlides[currentSlide].image}
            alt="Hero Background"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center">
          <div className="w-full max-w-4xl text-white">
            <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
                {heroSlides[currentSlide].title}
              </h2>
              <h3 className="text-lg md:text-2xl lg:text-3xl mb-4 md:mb-6 text-red-400">
                {heroSlides[currentSlide].subtitle}
              </h3>
              <p className="text-base md:text-xl mb-6 md:mb-8 text-gray-200 max-w-3xl">
                {heroSlides[currentSlide].description}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
                <Link
                  to={heroSlides[currentSlide].ctaLink}
                  className="bg-red-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-red-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  {heroSlides[currentSlide].cta}
                </Link>
                <button 
                  onClick={handlePhoneCall}
                  className="border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
                >
                  Llamar Ahora
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Slide Indicators */}
        <div className="absolute bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 md:space-x-3">
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all cursor-pointer ${
                index === currentSlide ? 'bg-red-600' : 'bg-white/50'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Nuestros Servicios</h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              Ofrecemos soluciones integrales en electrónica automotriz con tecnología de vanguardia 
              y personal altamente capacitado para garantizar el mejor servicio.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-16 md:h-16 bg-red-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                  <i className={`${service.icon} text-xl md:text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">{service.title}</h3>
                <p className="text-gray-600 mb-4 md:mb-6 text-sm md:text-base">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Productos Destacados</h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              Equipos y herramientas profesionales para diagnóstico y reparación automotriz
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-product-shop>
            {products.map((product) => (
              <div 
                key={product.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-48 md:h-64 object-cover object-top hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute top-3 md:top-4 left-3 md:left-4">
                    <span className="bg-red-600 text-white px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
                      {product.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-4 md:p-6">
                  <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 line-clamp-2">{product.name}</h3>
                  <p className="text-gray-600 text-sm mb-3 md:mb-4 line-clamp-2">{product.description}</p>
                  
                  {/* Rating */}
                  <div className="flex items-center mb-3 md:mb-4">
                    <div className="flex text-yellow-400">
                      {[...Array(5)].map((_, i) => (
                        <i 
                          key={i} 
                          className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-sm`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-gray-500 text-sm ml-2">({product.reviews})</span>
                  </div>

                  <button 
                    onClick={handleWhatsAppContact}
                    className="w-full bg-gray-900 text-white py-2 px-4 rounded-full hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
                  >
                    Ver Detalles
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8 md:mt-12">
            <Link 
              to="/productos?category=Baterías"
              className="bg-red-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-red-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer inline-block"
            >
              Ver Todas las Baterías
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">¿Por Qué Elegir Mechatronicx?</h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              Somos líderes en soluciones electrónicas automotrices con un compromiso inquebrantable 
              hacia la excelencia y la satisfacción del cliente.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {whyChooseUs.map((item, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 text-center cursor-pointer"
              >
                <div className="w-16 h-16 md:w-20 md:h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                  <i className={`${item.icon} text-2xl md:text-3xl text-red-600`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">{item.title}</h3>
                <p className="text-gray-600 text-sm md:text-base">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Location Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Nuestra Ubicación</h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              Visítanos en nuestro taller en Bogotá
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="space-y-6 md:space-y-8">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-lg md:text-xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2">Dirección</h3>
                  <p className="text-gray-600 text-sm md:text-base">Ave Cra 30 #29-09 Sur</p>
                  <p className="text-gray-600 text-sm md:text-base">Bogotá DC - Colombia</p>
                  <a 
                    href="https://www.google.com/maps/place/CENTRO+DE+ENSE%C3%91ANZA+AUTOMOVIL%C3%8DSTICA+-CEA+BOGOTA-/@4.5931886,-74.1172071,17z/data=!3m1!4b1!4m6!3m5!1s0x8e3f992f2ec4dcc7:0x5be805e4bf227be1!8m2!3d4.5931833!4d-74.1146322!16s%2Fg%2F11by_m4ntd!5m1!1e1?entry=ttu&g_ep=EgoyMDI1MTEwNC4xIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 transition-colors cursor-pointer inline-flex items-center mt-2 text-sm md:text-base"
                  >
                    Ver en Google Maps <i className="ri-external-link-line ml-1"></i>
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-lg md:text-xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2">Horarios de Atención</h3>
                  <div className="space-y-1 text-gray-600 text-sm md:text-base">
                    <p><span className="font-semibold">Lunes - Viernes:</span> 8:00 AM - 5:30 PM</p>
                    <p><span className="font-semibold">Sábado:</span> 8:00 AM - 2:00 PM</p>
                    <p><span className="font-semibold">Domingo:</span> Cerrado</p>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-lg md:text-xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2">Contacto Directo</h3>
                  <p className="text-gray-600 text-sm md:text-base">+57 320 204 7129</p>
                  <p className="text-gray-600 text-sm md:text-base">administrativo@mechatronicxsas.com</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.923!2d-74.1146322!3d4.5931833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f992f2ec4dcc7%3A0x5be805e4bf227be1!2sCENTRO%20DE%20ENSE%C3%91ANZA%20AUTOMOVIL%C3%8DSTICA%20-CEA%20BOGOTA-!5e0!3m2!1ses!2sco!4v1234567890123!5m2!1ses!2sco"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación Mechatronicx"
                className="md:h-96"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20 bg-gradient-to-r from-gray-900 to-red-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 md:mb-6">¿Necesitas Asistencia Especializada?</h2>
          <p className="text-lg md:text-xl mb-6 md:mb-8 max-w-3xl mx-auto">
            Nuestro equipo de expertos está listo para ayudarte con cualquier problema electrónico 
            de tu vehículo. Diagnóstico gratuito y cotización sin compromiso.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
            <button 
              onClick={handleWhatsAppContact}
              className="bg-red-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-red-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              Agendar Cita
            </button>
            <button 
              onClick={handlePhoneCall}
              className="border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Llamar Ahora
            </button>
            <button 
              onClick={handleWhatsAppContact}
              className="bg-green-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-base md:text-lg font-semibold hover:bg-green-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
            >
              WhatsApp
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div>
              <div className="flex items-center space-x-2 md:space-x-3 mb-4 md:mb-6">
                <img 
                  src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                  alt="Mechatronicx Logo" 
                  className="h-8 md:h-10 w-auto"
                />
                <div>
                  <h3 className="text-base md:text-lg font-bold">MECHATRONICX</h3>
                  <p className="text-xs text-gray-400">Soluciones Electrónicas</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4 text-sm md:text-base">
                Expertos en soluciones electrónicas automotrices con más de 10 años de experiencia.
              </p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/people/Mechatronicx-Especializado/100083428926459/?mibextid=wwXIfr&rdid=8FbzdNPEAxjlrs6r&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14SQyQT5X5o%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg md:text-xl"></i>
                </a>
                <a href="https://www.instagram.com/mechatronicxsas/?igsh=MTh0eDQ3MWhnMmh1NA%3D%3D" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg md:text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Servicios</h4>
              <ul className="space-y-2 md:space-y-3">
                <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Diagnóstico Automotriz</Link></li>
                <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Programación de Módulos</Link></li>
                <li><Link to="/servicios" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Llaves Inteligentes</Link></li>
                <li><Link to="/empresas" className="text-gray-400 hover:text-white transition-colors cursor-pointer text-sm md:text-base">Soluciones Empresariales</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Contacto</h4>
              <div className="space-y-2 md:space-y-3">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-red-500 mr-2 md:mr-3"></i>
                  <span className="text-gray-400 text-sm md:text-base">Ave Cra 30 #29-09 Sur, Bogotá DC</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-red-500 mr-2 md:mr-3"></i>
                  <span className="text-gray-400 text-sm md:text-base">320 204 7129</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-red-500 mr-2 md:mr-3"></i>
                  <span className="text-gray-400 text-sm md:text-base">administrativo@mechatronicxsas.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-base md:text-lg font-bold mb-4 md:mb-6">Horarios</h4>
              <div className="space-y-2 md:space-y-3 text-gray-400 text-sm md:text-base">
                <div>
                  <p className="font-semibold">Lunes - Viernes</p>
                  <p>8:00am - 5:30pm</p>
                </div>
                <div>
                  <p className="font-semibold">Sábado</p>
                  <p>8:00am - 2:00pm</p>
                </div>
                <div>
                  <p className="font-semibold">Domingo</p>
                  <p>Cerrado</p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 md:mt-12 pt-6 md:pt-8 text-center">
            <p className="text-gray-400 text-sm md:text-base">
              © 2024 Mechatronicx SAS. Todos los derechos reservados. | 
              <a href="https://maiketing.agency" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-400 ml-1 cursor-pointer">
                Powered by MAIketing.agency
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
